import Swiper from './SwiperContainer';

export default Swiper;
